module.exports = __webpack_public_path__ + "img/ad.7a5317d2.png";